export enum FileActionEnum {
  UploadToDrive = 'uploadToDrive',
  Download = 'download',
  ImportKes = 'importKes',
  ExportKes = 'exportKes',
  InsertHtml = 'insertHtml',
  ConvertImage = 'convertImage'
}
